import { manifest } from './manifest/manifest'
export const { extensions } = manifest
export default () => manifest.default
